import React from 'react';

import styles from './Advertisment.module.css';

export const Advertisment: React.FC = () => {
    const items = [
        {id: 1, accentText: '12', regularText: 'лет на рынке'},
        {id: 2, accentText: '115 000', regularText: 'клиентов'},
        {id: 3, accentText: '10 000+', regularText: 'отзывов'},
        {id: 4, accentText: '300 000+', regularText: 'автозапчасти'},
        {id: 5, accentText: 'до 3-х', regularText: 'лет гарантия'},
    ];

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>
                Почему выбирают нас
            </h1>
            <ul className={styles.list}>
                {items.map(({id, regularText, accentText}) => {
                    return (
                        <li key={id}>
                            <h3 className={styles.accentText}>{accentText}</h3>
                            <p className={styles.regularText}>{regularText}</p>
                        </li>
                    )
                })}
            </ul>
        </div>
    );
};